import React from 'react';
import {
    List,
    Datagrid,
    TextField,
    FunctionField,
    EditButton,
    DeleteButton,
} from 'react-admin';

const DAY_LABELS: Record<number, string> = {
    1: 'Mon', 2: 'Tue', 3: 'Wed', 4: 'Thu', 5: 'Fri', 6: 'Sat', 7: 'Sun',
};

const formatWorkDays = (days: number[] | null): string => {
    if (!days || !Array.isArray(days)) return '—';
    return days.map(d => DAY_LABELS[d] || String(d)).join(', ');
};

export const WorkScheduleList: React.FC = () => (
    <List>
        <Datagrid>
            <TextField source="name" label="Schedule Name" />
            <FunctionField
                label="Work Days"
                render={(record: any) => formatWorkDays(record?.work_days)}
            />
            <EditButton />
            <DeleteButton />
        </Datagrid>
    </List>
);
